/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */

export { readSchema } from "./read";
export { FQPN, parseFQPN, ProviderName } from "./provider-schema";
